import React from 'react';
import { Box, Option } from '@common-fe/common-fe';

import { ReactivationPlan } from '@/modules/employer/components/EmployerReactivation/types';

import { EmployerReactivationPlanField } from './EmployerReactivationPlan/EmployerReactivationPlanField';

interface Props {
  plans: ReactivationPlan[];
  options: Option[];
  hasFieldErrors?: boolean;
}

export const EmployerReactivationPlansList: React.FC<Props> = ({ plans, options, hasFieldErrors }) => {
  if (plans.length === 0) return null;

  return (
    <Box margin={{ top: 'spacing16' }}>
      {plans.map((plan, index) => (
        <React.Fragment key={plan.id}>
          {index > 0 && (
            <Box
              width="100%"
              height="1px"
              background={{ color: 'border1' }}
              margin={{ vertical: 'spacing16'}}
            />
          )}
          <EmployerReactivationPlanField
            testId={`EmployerReactivationCardAndPlans_plan_${plan.id}`}
            plan={plan}
            options={options}
            hasFieldErrors={hasFieldErrors}
          />
        </React.Fragment>
      ))}
    </Box>
  );
};
